import { cellRenderer, headerRenderer } from "../gifting/grid-utils";
import { useRef } from "react";
import { onContentReadySortArrow } from "@/helper/DxHelper";
import { DataGrid } from "devextreme-react";
import { Column, DataGridRef } from "devextreme-react/data-grid";
import { formatDate, formatNumber } from "devextreme/localization";
import { Rebalance } from "@/types/types";

type Props = {
  rebalances: Rebalance[];
};

export default function RebalancesGrid({ rebalances }: Props) {
  const datagridRef = useRef<DataGridRef>(null);

  return (
    <DataGrid
      className="ao-grid"
      dataSource={rebalances}
      showBorders={true}
      showRowLines={true}
      showColumnLines={true}
      wordWrapEnabled={true}
      keyExpr={"externalCode"}
      onContentReady={() => onContentReadySortArrow(datagridRef)}
      onCellPrepared={(e) => {
        if (e.rowType === "header") {
          const style = e.cellElement.style;
          style.backgroundColor = "var(--primary-color)";
          style.color = "white";
          style.borderBottom = "1px solid #fafafa";
        }
      }}
    >
      <Column
        dataField="date"
        dataType="date"
        allowSorting={false}
        allowEditing={false}
        alignment={"center"}
        headerCellRender={() => headerRenderer(`date`, "Date")}
        cellRender={(cellData) =>
          cellRenderer(
            cellData,
            "date",
            formatDate(new Date(cellData?.data?.date.toString()), "MMM dd, yyyy"),
            "",
            ""
          )
        }
      />
      <Column
        dataField="year"
        allowSorting={false}
        allowEditing={false}
        dataType="number"
        alignment={"center"}
        headerCellRender={() => headerRenderer(`amount`, "Amount")}
        cellRender={(cellData) =>
          cellRenderer(cellData, "amount", formatNumber(cellData?.data?.amount, "$ #,##0"), "", "")
        }
      />
      <Column
        dataField="rebalanceAccount"
        dataType="string"
        allowSorting={false}
        allowEditing={false}
        alignment={"center"}
        headerCellRender={() => headerRenderer(`acc`, "Account")}
        cellRender={(cellData) =>
          cellRenderer(cellData, "account", cellData?.data?.rebalanceAccount, "", "")
        }
      />
    </DataGrid>
  );
}
